import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const InvoiceStatusesLookupState = (state: RootState) => state.lookups.invoiceStatuses;

export const selectInvoiceStatuses = (state: RootState) => InvoiceStatusesLookupState(state).rows;
export const selectInvoiceStatusesLoading = (state: RootState) => InvoiceStatusesLookupState(state).loading;

export const selectInvoiceStatusById = createSelector(
  [selectInvoiceStatuses, (_: RootState, id?: string) => id],
  (rows, id) => rows.find(({ id: rowId }) => id === rowId),
);

export const selectLookupInvoiceStatuses = createSelector(selectInvoiceStatuses, (rows) =>
  rows.map(({ id, name }) => ({ id, name })),
);
